import logo from "../../../images/igs_logo.png";
import styles from "../../../styles/navbar.module.css";
import Search from "./Search";
import Menu from "./Menu";
import { useLocation } from "react-router-dom";

function Navbar() {
const location=useLocation();
  return (
    <nav className={location.pathname==="/" ? styles.nav:styles.navother}>
      <div className={styles.leftnav}>
        <img className={styles.logo} src={logo} alt="logo" />
        <div className={styles.schoolname}>
          <h1>INISA</h1>
          <h5>GRAMMAR SCHOOL</h5>
        </div>
      </div>

      <div className={styles.rightnav}>
        <Search></Search>
        <Menu></Menu>
      </div>
    </nav>
  );
}

export default Navbar;
